import React, {useEffect, useRef} from 'react'
import {useInView} from 'motion/react'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'

import {useSectionTracker} from './useSectionTracker'

export const SectionTracker = ({children}: {children: React.ReactNode}) => {
  const {isMobile} = useDeviceLayout()
  return (
    <>
      {isMobile
        ? children
        : React.Children.toArray(children).map((child, index) => (
            <SectionWrapper key={index} position={index}>
              {child}
            </SectionWrapper>
          ))}
    </>
  )
}

const SectionWrapper = ({
  children,
  position
}: {
  children: React.ReactNode
  position: number
}) => {
  const {reportSectionVisibility, registerSection, unregisterSection} =
    useSectionTracker()

  const inViewRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = inViewRef.current
    if (element) {
      registerSection(position, element)
      return () => {
        unregisterSection(position)
      }
    }
  }, [position, registerSection, unregisterSection])

  const isInView = useInView(inViewRef, {
    amount: 0.1
  })

  useEffect(() => {
    reportSectionVisibility({
      position,
      isVisible: isInView
    })
  }, [isInView, reportSectionVisibility, position])

  return <div ref={inViewRef}>{children}</div>
}
